export const locale = {
  lang: 'vn',
  data: {
    PAGINATION: {
      ITEM_PER_PAGE: 'Hiển thị mỗi trang',
      OF: 'trên'
    }
  }
};
